<template>
  <div class="appHome">
    <router-view />
    <div class="backTop" v-if="backShow" @click="backTop">
      <img src="./assets/backTop.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  watch: {
    $route() {
      document.title = this.$route.meta.title;
    },
  },
  data() {
    return {
      backShow: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    document.title = this.$route.meta.title;
  },
  methods: {
    backTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.backShow = false;
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 800) {
        this.backShow = true;
      } else {
        this.backShow = false;
      }
    },
  },
};
</script>

<style>
.appHome {
  position: relative;
}
.backTop {
    cursor: pointer;
  position: fixed;
  right: 100px;
  bottom: 100px;
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 4px;
  background: rgba(91, 108, 121, 0.4);
  z-index: 300;
  /* border-radius: 50%; */
}
</style>
